
import { useCallback, useEffect, useState } from "react";
import { HiveAPI } from "../api/hivemind";

export default function useHiveMind(mapId) {
  const [moves, setMoves] = useState([]);
  const [participants, setParticipants] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!mapId) return;
    try {
      const [m, p] = await Promise.all([HiveAPI.getMoves(mapId), HiveAPI.participants(mapId)]);
      setMoves(m);
      setParticipants(p.usernames || []);
    } catch (e) {
      console.error("HiveMind refresh error:", e);
    } finally {
      setLoading(false);
    }
  }, [mapId]);

  useEffect(() => {
    setLoading(true);
    refresh();
  }, [refresh]);

  return { moves, participants, loading, refresh };
}
